import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const LayerListWidget = ({ view }) => {
  useEffect(() => {
    if (!view || !view.ui) return;

    let layerList, layerListExpand, legend, legendExpand;

    loadModules([
      'esri/widgets/LayerList',
      'esri/widgets/Legend',
      'esri/widgets/Expand'
    ]).then(([LayerList, Legend, Expand]) => {
      // LayerList widget
      layerList = new LayerList({ view });
      layerListExpand = new Expand({
        expandTooltip: "Layer List",
        view,
        content: layerList,
        expandIconClass: 'esri-icon-layers',
        expanded: false
      });

      // Legend widget
      legend = new Legend({ view });
      legendExpand = new Expand({
        expandTooltip: "Legend",
        view,
        content: legend,
        expandIconClass: 'esri-icon-legend',
        expanded: false
      });

      // Add both widgets to the UI
      view.ui.add(layerListExpand, { position: 'top-left', index: 2 });
      view.ui.add(legendExpand, { position: 'top-left', index: 3 });
    });

    return () => {
      if (view?.ui) {
        if (layerListExpand) {
          view.ui.remove(layerListExpand);
          layerListExpand.destroy();
        }
        if (legendExpand) {
          view.ui.remove(legendExpand);
          legendExpand.destroy();
        }
      }
      if (layerList) layerList.destroy();
      if (legend) legend.destroy();
    };
  }, [view]);

  return null;
};

export default LayerListWidget;
